import React, { Fragment, useState } from "react";
import { Button, UncontrolledTooltip } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { ConfirmationModal } from "../../../../layout/Modal/ConfirmationModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { resetUserPassword as resetUserPasswordApi } from "../../../../../api/clients/users";
import { Link } from "react-router-dom";
import {
  ACL,
  USER_DELETE_STATUSES,
  USER_STATUSES
} from "../../../../../config/constants";
import { NOTIFICATION_CLIENT_ACTIONS } from '../../../../../config/notifications';
import { store } from '../../../../../store/store';
import { hideNotification } from '../../../../../store/actions/notification';

function ResetPasswordClient(props) {
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const {index, actionCallback, user, showIcon} = props;

  if (! ACL.CLIENT.USERS.RESET_PASSWORD.hasAccess()) {
    return null;
  }

  const resetUserPassword = () => {
    resetUserPasswordApi({
      email: user.email,
      notificationId: NOTIFICATION_CLIENT_ACTIONS
    }).then((response) => {
      setShowResetPasswordModal( false );

      if (response && response.data && response.status === 201) {
        actionCallback();
      }
    });
  };

  const shouldDisplay = (user) => {
    return (!user || USER_DELETE_STATUSES.includes(user.status) || user.status === USER_STATUSES.INACTIVE) ? false : true;
  }

  if (! shouldDisplay(user)) {
    return null;
  }

  return (<Fragment>
      {!showIcon ?
        <Fragment>
          <Button
            color="primary"
            size="sm"
            className="btn-warning"
            type="button"
            id={`reset-password-icon-${index}`}
            onClick={() => {
              store.dispatch(hideNotification());
              setShowResetPasswordModal(true)
            }}
          >
            <FormattedMessage
              id="messages.reset_user_password"/>
          </Button>
          <UncontrolledTooltip
            delay={0}
            target={`reset-password-icon-${index}`}
            boundariesElement="viewport"
            positionFixed
          >
            <FormattedMessage
              id="messages.reset_user_password"/>
          </UncontrolledTooltip>
        </Fragment> :
        <Fragment>
          <Link
            to="#"
            className="cursor-pointer px-2 mx-2 link-icon-color"
            id={`reset-password-icon-` + props.index}
            onClick={() => setShowResetPasswordModal(true)}
          >
            <FontAwesomeIcon
              size="lg"
              className="cursor-pointer"
              pointerEvents="none"
              icon={faLock}
            />
          </Link>
          <UncontrolledTooltip
            delay={0}
            target={`reset-password-icon-${props.index}`}
            boundariesElement="viewport"
            positionFixed
          >
            <FormattedMessage
              id="messages.reset_user_password"/>
          </UncontrolledTooltip>
        </Fragment>
      }

      <ConfirmationModal
        showModal={showResetPasswordModal}
        closeModal={() => setShowResetPasswordModal(false)}
        confirmationYes={resetUserPassword}
        messageId="messages.confirm_reset_user_password"
      />
    </Fragment>
  );
}

export { ResetPasswordClient };
